import { nectarApi } from './client'
import type {
  AssessmentProgress,
  CefrLevel,
  PaginatedResponse,
  ProficiencyAssessment,
  SpeechQuestion,
  TextQuestion
} from './models'

export const createAssessment = (body: { selfAssessedLevel: CefrLevel; language: string }, turnstileToken?: string) =>
  nectarApi.post<ProficiencyAssessment>(
    '/v1/proficiency-assessments',
    body,
    turnstileToken ? { headers: { 'X-Turnstile-Token': turnstileToken } } : { headers: { 'X-Turnstile-Token': 'test' } }
  )

export const getAssessmentsByLanguage = (language: string) =>
  nectarApi.get<PaginatedResponse<ProficiencyAssessment>>('/v1/proficiency-assessments', {
    language,
    limit: 50
  })

export const getAssessment = (id: string) => nectarApi.get<ProficiencyAssessment>(`/v1/proficiency-assessments/${id}`)

export const getTextQuestion = (id: string) =>
  nectarApi.get<{ question: TextQuestion | null; progress: AssessmentProgress }>(
    `/v1/proficiency-assessments/${id}/text-questions`
  )

export const submitTextAnswer = (id: string, body: { questionId: string; selectedOptionIndex: number | null }) =>
  nectarApi.post<{ submitted: boolean; progress: AssessmentProgress }>(
    `/v1/proficiency-assessments/${id}/text-answers`,
    body
  )

export const completeTextPhase = (id: string) =>
  nectarApi.post<ProficiencyAssessment>(`/v1/proficiency-assessments/${id}/complete-text`)

export const getSpeechQuestions = (id: string) =>
  nectarApi.get<{ questions: SpeechQuestion[]; progress: AssessmentProgress }>(
    `/v1/proficiency-assessments/${id}/speech-questions`
  )

export const submitSpeechAnswer = (id: string, formData: FormData) =>
  nectarApi.post<{ id: string; progress: AssessmentProgress }>(
    `/v1/proficiency-assessments/${id}/speech-answers`,
    formData
  )

export const completeAssessment = (id: string) =>
  nectarApi.post<ProficiencyAssessment>(`/v1/proficiency-assessments/${id}/complete`)
